<template>
  <div class="checkout" v-if="detailCart">
    <modalAddAddress ref="modalAddAddress" @action="saveAddress"></modalAddAddress>
    <modalCourier ref="modalCourier" @action="selectCour" :showPickupStore="!detailCart.is_retail_product"></modalCourier>
    <modalTransfer ref="modalTransfer" @action="checkoutTransfer"></modalTransfer>
    <modalSelectAddress ref="modalAddress" @action="selectAddress"></modalSelectAddress>
    <modalConfirm ref="modalConfirm" confirm-text="Yakin" @action="paymentStore" confirmColor="#1951EF">
      <template v-slot:title>
        <span class="black--text text-capitalize font-weight-bold">Konfirmasi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">Apakah Anda yakin untuk memproses transaksi dengan pembayaran di toko?</div>
      </template>
    </modalConfirm>
    <modalConfirm ref="modalConfirmTransfer" confirm-text="Yakin" @action="paymentStore" confirmColor="#1951EF">
      <template v-slot:title>
        <span class="black--text text-capitalize font-weight-bold">Konfirmasi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">Apakah Anda yakin untuk memproses transaksi dengan pembayaran di toko?</div>
      </template>
    </modalConfirm>
    <modalConfirm ref="modalConfirmVA" confirm-text="Yakin" @action="payWithVA" confirmColor="#1951EF">
      <template v-slot:title>
        <span class="black--text text-capitalize font-weight-bold">Konfirmasi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">Apakah Anda yakin untuk memproses transaksi dengan pembayaran VA BCA?</div>
      </template>
    </modalConfirm>
    <v-col class="pt-5">
      <div v-if="selectedCour != 'pick_up'">
        <v-card elevation="0" class="py-1 rounded-lg psr-border">
          <v-col class="py-0">
            <v-row class="justify-space-between">
              <v-col class="text-body-2 black--text my-auto">
                <v-icon class="mt-n1" color="#1951EF">mdi-map-marker</v-icon>
                <span class="pl-3 font-weight-bold black--text">Alamat Pengiriman</span>
              </v-col>
              <v-col cols="3" md="4" class="text-right text-body-2" v-if="selectedAddress != null">
                <v-btn outlined color="#1951EF" class="rounded-lg" @click="openModalAddAddress">
                  <v-icon color="black">mdi-plus</v-icon>
                  <span class="pl-2 text-body-2 font-weight-bold text-capitalize d-none d-md-inline">Tambah Alamat</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row v-if="selectedAddress">
              <v-col cols="12" sm="3" md="3" class="pt-0">
                <div>
                  <div class="text-subtitle-2 grey--text text--darken-1">Nama Penerima</div>
                  <div class="text-body-1 font-weight-bold">{{ selectedAddress.user_address_receipt_name }}</div>
                </div>
                <div class="pt-3 pt-sm-4">
                  <div class="text-subtitle-2 grey--text text--darken-1">Nomor Handphone</div>
                  <div class="text-body-1 font-weight-bold">{{ selectedAddress.user_address_mobilephone }}</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="7" class="pl-sm-0 pt-0">
                <div>
                  <div class="text-subtitle-2 grey--text text--darken-1">Alamat</div>
                  <div class="text-body-1">{{ addressText(selectedAddress) }}</div>
                  <div class="pt-1 text-body-2"
                    v-if="selectedAddress.user_address_latitude != '' && selectedAddress.user_address_longitude != ''">
                    <span>Lat/Long :</span>
                    <span class="pl-1">
                      <a target="_blank"
                        :href="'http://www.google.com/maps/place/' + selectedAddress.user_address_latitude + ',' + selectedAddress.user_address_longitude">{{
                          selectedAddress.user_address_latitude }} / {{ selectedAddress.user_address_longitude }}</a>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="3" md="2" class="pt-md-0 mt-md-n1 d-flex justify-center">
                <v-btn text color="grey darken-2" class="font-weight-bold text-capitalize"
                  v-if="selectedAddress.user_address_is_used == 'used'">Utama</v-btn>
                <v-btn text color="indigo" class="font-weight-bold text-capitalize" @click="openModalAddress">Ubah</v-btn>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="6" md="6" class="pt-0">
                <div class="d-flex">
                  <div class="pl-5">
                    <img width="100" src="/assets/icons/ilus-tidak-ada-alamat.svg" />
                  </div>
                  <div class="pl-3 text-body-2 my-auto">Opps alamat pengiriman belum ada...</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pt-0 text-right my-auto">
                <v-btn x-large depressed color="#1951EF" class="font-weight-bold rounded-lg text-body-2 white--text"
                  @click="openModalAddAddress">
                  <v-icon>mdi-plus-circle</v-icon>
                  <span class="pl-3">Tambah Alamat</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-alert v-model="responseError.address" v-if="responseError.address" dense color="red lighten-1"
              class="white--text" dismissible>{{ responseError.address.message }}</v-alert>
          </v-col>
          <v-col class="pb-0 pt-0 pt-md-3 d-none">
            <div class="primary-border"></div>
          </v-col>
          <v-col class="py-0 d-none">
            <v-checkbox class="mt-2 pb-3" label="Opsi Dropshipper" hide-details="auto"></v-checkbox>
          </v-col>
        </v-card>
      </div>
      <div class="pt-5" v-if="Object.values(detailCart).length > 0">
        <v-card elevation="0" class="rounded-lg psr-border">
          <v-col class="py-1">
            <v-row>
              <v-col cols="12" md="8" class="text-body-2 primary-2--text">
                <v-icon class="mt-n1" color="#1951EF">mdi-storefront</v-icon>
                <span class="pl-3 font-weight-bold black--text">{{ detailCart.store.store_name }}</span>
              </v-col>
              <v-col md="2" class="d-none d-md-block text-body-2 text-center">
                <div>Jumlah</div>
              </v-col>
              <v-col md="2" class="d-none d-md-block text-body-2 text-right">
                <div>Subtotal</div>
              </v-col>
            </v-row>
            <v-row v-for="product in detailCart.product" :key="product.cart_detail_id">
              <v-col cols="4" sm="2" md="2" lg="1" class="pb-0 pr-md-0">
                <v-card outlined>
                  <div class="pa-1">
                    <v-img class="rounded-lg mx-auto" width="70" height="70" :src="product.product_image"></v-img>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="8" sm="5" md="6" lg="7" class="pb-0 pl-0 pl-md-3 my-sm-auto">
                <div class="pl-3 text-body-2 my-auto">
                  {{ product.product_name }}
                  <div class="text-caption">
                    <span v-if="product.product_enable_discount == '1'" class="red white--text">{{
                      product.product_discount_percent | toNumber }}%</span>
                    &nbsp;
                    <strike v-if="product.product_enable_discount == '1'">Rp {{ product.product_gross | toNumber
                    }}</strike>
                  </div>
                   <v-badge v-if="product.product_physique =='ebook'" color="red darken-1" content="E-book" inline  >
                                     
                    </v-badge>
                </div>

                <div class="pl-3 text-body-2 my-auto" v-if="product.product_pv > 0">{{ product.product_pv }} PV</div>
                <div class="d-block d-sm-none">
                  <div class="pl-3 text-caption">{{ product.cart_detail_quantity | toNumber }}</div>
                  <div class="pl-3 font-weight-bold">Rp {{ product.product_price * product.cart_detail_quantity |
                    toNumber }}</div>
                </div>
              </v-col>
              <v-col md="2" class="d-none d-sm-block pb-0 text-body-2 text-center my-auto">
                <div>{{ product.cart_detail_quantity | toNumber }}</div>
              </v-col>
              <v-col sm="3" md="2" class="d-none d-sm-block pb-0 text-body-2 text-right my-auto">
                <div class="font-weight-bold">Rp {{ product.product_price * product.cart_detail_quantity | toNumber }}
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pb-0">
            <div class="primary-border"></div>
          </v-col>
          <v-col class="text-body-2">
            <v-row class="justify-end">
              <v-col cols="12" sm="2" md="2" class="pr-0 my-auto">
                <div class="font-weight-bold">Opsi Pengiriman :</div>
              </v-col>
              <v-col v-if="typeof selectedCour == 'object' && Object.values(selectedCour).length > 0" cols="12" sm="5"
                md="4" class="pr-md-0 py-0 py-md-3">
                <div class="d-flex">
                  <div class="my-auto">
                    <v-img width="80" :src="'/assets/courier/' + selectedCour.id.toLowerCase() + '.svg'"></v-img>
                  </div>
                  <div class="my-auto pl-3">
                    <div class="font-weight-bold">{{ selectedCour.description }}</div>
                    <div class="pt-1 text-uppercase">{{ selectedCour.id }} {{ selectedCour.code }}</div>
                    <div class="pt-1 text-caption grey--text text--darken-1">{{ selectedCour.etd }}</div>
                  </div>
                </div>
              </v-col>
              <v-col v-else-if="selectedCour == 'pick_up'" cols="12" sm="5" md="4"
                class="pr-md-0 py-0 py-md-3 my-auto">Tanpa kurir pengiriman</v-col>
              <v-col v-else cols="12" sm="5" md="4" class="pr-md-0 py-0 py-md-3 my-auto">Silahkan pilih pengiriman</v-col>
              <v-col v-if="Object.values(selectedCour).length > 0" sm="2" md="1" class="my-auto text-sm-center">
                <v-btn v-show="false" :loading="loadingProcess" text color="indigo" class="px-0 font-weight-bold text-capitalize"
                  @click="openModalCour">Ganti</v-btn>
              </v-col>
              <v-col v-else-if="Object.values(selectedCour).length == 0 && selectedCour != 'pick_up'" sm="2" md="1"
                class="my-auto text-sm-center">
                <v-btn :loading="loadingProcess" text color="indigo" class="font-weight-bold text-capitalize"
                  @click="openModalCour">Pilih</v-btn>
              </v-col>
              <v-col sm="3" md="3" class="my-auto text-body-2 text-right">
                <div class="font-weight-bold">Rp {{ selectedCour.cost ? selectedCour.cost : 0 | toNumber }}</div>
              </v-col>
            </v-row>
            <v-alert v-model="responseError.courier" v-if="responseError.courier" dense color="red lighten-1"
              class="white--text" dismissible>{{ responseError.courier.message }}</v-alert>
          </v-col>
          <v-col class="py-0" v-show="saldoCoinGen > 0">
            <div class="primary-border"></div>
          </v-col>

          <v-col class="text-body-2" v-show="saldoCoinGen > 0">
            <v-row class="justify-end">
              <v-col cols="12" sm="2" md="2" class="pr-0 my-auto">
                <div class="font-weight-bold">Opsi Pembayaran :</div>
              </v-col>
              <v-col sm="7" md="7" class="my-auto text-sm-center">
                <b>Pakai Coin Gen (Rp {{ saldoCoinGen | toNumber }})</b>
              </v-col>
              <v-col sm="1" md="1" class="my-auto text-body-2 text-right">
                <v-switch :disabled="(saldoCoinGen < 1) ? true : false" v-model="switchCoinGen"></v-switch>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col class="text-body-2" v-if="switchCoinGen==false || saldoCoinGen<(productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0))">
            <v-row class="justify-end">
              <v-col cols="12" sm="2" md="2" class="pr-0 my-auto">
                <div class="font-weight-bold"></div>
              </v-col>
              <v-col sm="4" md="4" class="my-auto text-body-2 text-right">
                <v-btn
                  v-if="loadcart"
                  depressed
                  height="50"
                  block
                  color="#1951EF"
                  class="rounded-lg"
                >
                  <div class="font-weight-bold text-body-2">Metode Pembayaran Lain</div>
                </v-btn>
                <v-menu offset-y v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      height="50"
                      block
                      color="#1951EF"
                      class="rounded-lg"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <div class="font-weight-bold text-body-2 white--text">Metode Pembayaran Lain</div>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="checkout('transfer')">
                      <v-list-item-title class="text-body-1">Pembayaran Manual</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="checkout('virtual_account')" v-if="false">
                      <v-list-item-title class="text-body-1">Pembayaran VA BCA</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.prevent="checkout('midtrans')">
                      <v-list-item-title class="text-body-1">Pembayaran Otomatis</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-show="false"
                      @click="checkout('payment_store')"
                      v-if="detailCart.is_retail_product === false"
                    >
                      <v-list-item-title class="text-body-1">Pembayaran Ditoko</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>-->

          <v-col class="py-0">
            <div class="primary-border"></div>
          </v-col>
          <v-col class="py-4 py-md-5">
            <div class="d-sm-flex justify-end text-body-2">
              <div>Total Belanja ({{ detailCart.product.length | toNumber }} Produk)</div>
              <div>
                <div v-if="Object.values(selectedCour).length > 0"
                  class="pl-sm-5 pt-2 pt-sm-0 text-body-1 font-weight-bold primary-2--text">Rp {{ productTotal.price_total +
                    (selectedCour.cost ? selectedCour.cost : 0) | toNumber }}</div>
                <div v-else class="pl-sm-5 pt-2 pt-sm-0 text-body-1 font-weight-bold primary-2--text">Rp
                  {{ productTotal.price_total | toNumber }}</div>
              </div>
            </div>
            <div class="d-sm-flex justify-end text-body-2" v-if="switchCoinGen && saldoCoinGen > 0">
              <div>Coin Gen</div>
              <div>
                <div class="pl-sm-5 pt-2 pt-sm-0 text-body-1 font-weight-bold primary-2--text"
                  v-if="(saldoCoinGen > (productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0)))">- Rp {{
                    (productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0)) | toNumber }}</div>
                <div v-else class="pl-sm-5 pt-2 pt-sm-0 text-body-1 font-weight-bold primary-2--text">- Rp {{ saldoCoinGen |
                  toNumber }}</div>
              </div>
            </div>
            <div class="d-sm-flex justify-end text-body-2" v-if="switchCoinGen && saldoCoinGen > 0">
              <template v-if="(saldoCoinGen < (productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0)))">
                <div>Tagihan</div>
                <div>
                  <div class="pl-sm-5 pt-2 pt-sm-0 text-body-1 font-weight-bold primary-2--text">Rp {{
                    Math.abs(saldoCoinGen - (productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0))) |
                    toNumber }}</div>
                </div>
              </template>
            </div>
          </v-col>
        </v-card>
      </div>
      <v-form ref="registrationMLM" role="form">
        <div class="pt-5" v-if="mlmShow">
          <v-card elevation="0" class="py-1 rounded-lg psr-border">
            <v-col v-if="detailCart.registration === true">
              <div class="text-body-2 primary-2--text">
                <v-icon class="mt-n1" color="primary">mdi-file-account</v-icon>
                <span class="pl-3 font-weight-bold">Form Registrasi Gen Indonesia</span>
              </div>
            </v-col>
            <v-col>
              <v-row v-if="detailCart.registration === true">
                <v-col cols="12" sm="6" md="6">
                  <div>
                    <div class="text-body-2 font-weight-bold pb-1">Nomor KTP</div>
                    <v-text-field v-model="identity_number" @blur="checkKTP()" @keypress="onlyNumber"
                      @paste="validatePaste($event)" @focus="() => ktp_error = ''" :error-messages="ktp_error"
                      validate-on-blur maxlength="16" :rules="rulesKTP" single-line outlined
                      class="rounded-lg text-body-2" placeholder="Nomor KTP" dense hide-details="auto"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <div>
                    <div class="text-body-2 font-weight-bold pb-1">
                      Sponsor
                      <span v-if="sponsor_name">
                        (
                        <span class="primary-2--text">{{ sponsor_name }}</span>)
                      </span>
                    </div>
                    <v-text-field v-model="sponsor" @blur="checkUserMLM(sponsor, 'sponsor')" @keypress="onlyNumber"
                      @paste="validatePaste($event)" @focus="() => sponsor_name_error = ''"
                      :error-messages="sponsor_name_error" validate-on-blur single-line outlined
                      class="rounded-lg text-body-2" placeholder="Nomor Handphone Sponsor" dense
                      hide-details="auto"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <div>
                    <div class="text-body-2 font-weight-bold pb-1">Posisi Berdasarkan</div>
                    <v-autocomplete v-model="position_by" :items="position_option" single-line outlined
                      class="rounded-lg text-body-2" dense hide-details="auto"
                      no-data-text="Tidak ada data"></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" v-if="position_by == 'upline'">
                  <div>
                    <div class="text-body-2 font-weight-bold pb-1">
                      Upline
                      <span v-if="upline_name">
                        (
                        <span class="primary-2--text">{{ upline_name }}</span>)
                      </span>
                    </div>
                    <v-text-field v-model="upline" @blur="checkUserMLM(upline, 'upline')" @keypress="onlyNumber"
                      @paste="validatePaste($event, true)" @focus="() => upline_name_error = ''"
                      :error-messages="upline_name_error" @change="sponsor_position = ''" validate-on-blur single-line
                      outlined class="rounded-lg text-body-2" placeholder="Nomor Handphone Upline" dense
                      hide-details="auto"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" v-if="position_by">
                  <div>
                    <div class="text-body-2 font-weight-bold pb-1">Posisi</div>
                    <v-autocomplete v-model="position_selected" :items="position" single-line outlined
                      class="rounded-lg text-body-2" dense hide-details="auto"
                      no-data-text="Tidak ada data"></v-autocomplete>
                  </div>
                </v-col>
              </v-row>
              <div class="text-body-2" v-if="detailCart.cart_suggest">
                <v-alert class="text-body-2 rounded-lg mt-3 mb-2" text color="primary" :icon="false"
                  v-if="detailCart.cart_suggest.next.msg && detailCart.cart_suggest.available.value != 'PREMIUM'">
                  <div class="d-md-flex justify-space-between text-center">
                    <div class="my-auto">{{ detailCart.cart_suggest.next.msg }}.</div>
                    <div class="pt-3 pt-md-0">
                      <router-link to="/" class="text-deco">
                        <v-btn depressed color="primary" class="text-capitalize rounded-lg">Belanja sekarang</v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-alert>
                <v-alert class="text-body-2 rounded-lg mt-3 mb-2" text color="primary" :icon="false" v-else>
                  <div class="d-md-flex justify-space-between text-center">
                    <div class="my-auto">{{ detailCart.cart_suggest.available.msg }}.</div>
                  </div>
                </v-alert>
              </div>
            </v-col>
          </v-card>
        </div>
      </v-form>
      <template v-show="false">
        <div class="pt-5" v-if="selectedCour == 'pick_up'">
          <v-card elevation="0" class="py-1 rounded-lg psr-border">
            <v-col class="py-0">
              <v-row class="justify-space-between">
                <v-col class="text-body-2 primary-2--text my-auto">
                  <v-icon class="mt-n1" color="#3645e9">mdi-map-marker</v-icon>
                  <span class="pl-3 font-weight-bold">Alamat Toko</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <v-col cols="12" sm="3" md="3" class="pt-0">
                  <div>
                    <div class="text-subtitle-2 grey--text text--darken-1">Nama Pemilik Toko</div>
                    <div class="text-body-1 font-weight-bold">{{ detailStoreAddress.user_name }}</div>
                  </div>
                  <div class="pt-3 pt-sm-4">
                    <div class="text-subtitle-2 grey--text text--darken-1">Nomor Handphone</div>
                    <div class="text-body-1 font-weight-bold">{{ detailStoreAddress.user_mobilephone }}</div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="pl-sm-0 pt-0">
                  <div>
                    <div class="text-subtitle-2 grey--text text--darken-1">Alamat</div>
                    <div class="text-body-1">{{ addressTextStore(detailStoreAddress) }}</div>
                  </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="pt-md-0 pb-0 pr-md-5"  v-show="false">
                  <div class="text-subtitle-2 grey--text text--darken-1 pb-1">Tanggal Pengambilan</div>
                  <v-menu v-model="pickDate" :close-on-content-click="true" :nudge-right="0" transition="scale-transition"
                    offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field placeholder="Pilih Tanggal" outlined dense append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" :value="pickup_date | tanggalIndo" class="text-body-2"
                        clearable></v-text-field>
                    </template>
                    <v-date-picker locale="id" first-day-of-week="0" color="primary" :min="today"
                      @input="responseError.pick_up_date = ''" v-model="pickup_date"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-alert v-model="responseError.pick_up_date" v-if="responseError.pick_up_date" dense color="red lighten-1"
                class="white--text" dismissible>{{ responseError.pick_up_date.message }}</v-alert>
            </v-col>
            <v-col class="pb-0 pt-0 pt-md-3 d-none">
              <div class="primary-border"></div>
            </v-col>
            <v-col class="py-0 d-none">
              <v-checkbox class="mt-2 pb-3" label="Opsi Dropshipper" hide-details="auto"></v-checkbox>
            </v-col>
          </v-card>
        </div>
      </template>
      <div class="pt-3">
        <v-row class="justify-end">
          <v-col md="2">
            <v-btn :loading="loadingProcess" depressed height="50" block color="#1951EF" class="rounded-lg mr-3" outlined
              @click="backToCart">
              <div class="font-weight-bold text-body-2">Kembali</div>
            </v-btn>
          </v-col>
          <v-col md="3" class>
            <!-- <template
              v-if="switchCoinGen==false || saldoCoinGen<(productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0))"
            >
              <v-btn v-if="loadcart" depressed height="50" block color="#1951EF" class="rounded-lg">
                <div class="font-weight-bold text-body-2">Pilih Metode Pembayaran</div>
              </v-btn>
              <v-menu offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    height="50"
                    block
                    color="#1951EF"
                    class="rounded-lg"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="font-weight-bold text-body-2 white--text">Metode Pembayaran Lain</div>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="checkout('transfer')" v-if="false">
                    <v-list-item-title class="text-body-1">Pembayaran Manual</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="checkout('virtual_account')" v-if="false">
                    <v-list-item-title class="text-body-1">Pembayaran VA BCA</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.prevent="checkout('midtrans')">
                    <v-list-item-title class="text-body-1">Pembayaran Otomatis</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-show="false"
                    @click="checkout('payment_store')"
                    v-if="detailCart.is_retail_product === false"
                  >
                    <v-list-item-title class="text-body-1">Pembayaran Ditoko</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>-->
            <template
              v-if="switchCoinGen == false || saldoCoinGen < (productTotal.price_total + (selectedCour.cost ? selectedCour.cost : 0))">
              <v-btn :loading="loadingProcess" height="50" block color="#1951EF" depressed
                class="text-capitalize font-weight-bold rounded-lg white--text" @click.prevent="checkout('midtrans')">
                <div class="font-weight-bold text-body-2 white--text">Lanjutkan Pembayaran</div>
              </v-btn>
            </template>
            <template v-else>
              <v-btn :loading="loadingProcess" height="50" block color="#1951EF" depressed
                class="text-capitalize font-weight-bold rounded-lg white--text"
                @click="checkoutFullCoinGen">Proses</v-btn>
            </template>
            <!-- <v-btn v-else depressed height="50" block color="primary" class="rounded-lg" @click.prevent="checkout('midtrans')">
							<div class="font-weight-bold text-body-2">Pilih Metode Pembayaran</div>
            </v-btn>-->
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
// import modalAddAddress from "@/views/store/cart/ModalAddAddress";
import modalAddAddress from "@/views/store/cart/ModalAddAddressV2";
import modalSelectAddress from "@/views/store/cart/ModalSelectAddressV2";
import modalCourier from "@/views/store/cart/ModalCourier";
import modalTransfer from "@/views/store/cart/ModalTransfer";
import { midtransURL } from "@/config";
import { midtransKey } from "@/config";
import apiAuth from "@/helpers/auth";
import modalConfirm from "@/components/ModalDelete";

export default {
  components: {
    modalSelectAddress,
    modalAddAddress,
    modalCourier,
    modalTransfer,
    modalConfirm
  },
  data() {
    return {
      mustChooseOngkir: false,
      loadingProcess: false,
      grandTotal: 0,
      grandWeightTotal: 0,
      switchCoinGen: true,
      selectedAddress: null,
      selectedCour: "",
      selectedBankAccount: {},
      sponsor: "",
      sponsor_position: "",
      upline: "",
      position_selected: "",
      pickup_date: "",
      pickDate: "",
      identity_number: "",
      position_by: "sponsor",
      position_option: [
        {
          text: "Sponsor",
          value: "sponsor"
        },
        {
          text: "Upline",
          value: "upline"
        }
      ],
      position: [
        {
          text: "Otomatis",
          value: ""
        },
        {
          text: "Kiri",
          value: "L"
        },
        {
          text: "Kanan",
          value: "R"
        }
      ],
      random_number: "",
      ktp_error: "",
      sponsor_name: "",
      upline_name: "",
      sponsor_name_error: "",
      upline_name_error: ""
    };
  },
  computed: {
    ...mapState("cart", [
      "detailCart",
      "loadcart",
      "responseError",
      "saldoCoinGen"
    ]),
    // ...mapState("address", ["addressData"]),
    ...mapState("addressKiriminaja", ["addressData"]),
    ...mapState("auth", ["userData"]),
    ...mapState("store", ["detailStoreAddress"]),

    rulesKTP() {
      let rules = [];
      if (this.identity_number) {
        rules = [v => v.length == 16 || "No. KTP tidak sesuai"];
      }
      return rules;
    },
    mlmShow() {
      let show = false;
      if (
        this.detailCart.cart_suggest ||
        this.detailCart.registration === true
      ) {
        if (this.detailCart.cart_suggest.next) {
          if (
            this.detailCart.cart_suggest.next.msg ||
            this.detailCart.cart_suggest.available.msg
          ) {
            show = true;
          }
        }
      }
      return show;
    },
    productTotal() {
      let grandTotal = 0;
      let weightTotal = 0;
      let weightTotalVolume = 0;
      console.log("this.detailCart.product", this.detailCart.product);
      if (this.detailCart.product) {
        this.detailCart.product.forEach(el => {
          grandTotal += el.product_price * el.cart_detail_quantity;
          weightTotal += parseInt(el.product_weight) * el.cart_detail_quantity;
          let subtotalWeightVolume =
            (el.product_length *
              el.product_width *
              el.product_height *
              el.cart_detail_quantity) /
            6;
          weightTotalVolume += subtotalWeightVolume;

          // weightTotalVolume += parseInt(el.product_weight) * el.cart_detail_quantity;
        });
      }
      this.grandWeightTotal = weightTotal;

      if (weightTotal < weightTotalVolume) {
        this.grandWeightTotal = weightTotalVolume;
        weightTotal = weightTotalVolume;
      }
      // console.log("weightTotalVolume", weightTotalVolume);

      this.grandTotal = grandTotal;
      return {
        // weight_total: weightTotal,
        weight_total: weightTotal,
        price_total: grandTotal
      };
    }
  },
  methods: {
    // ...mapActions("address", ["getAddress", "addAddress"]),
    ...mapActions("addressKiriminaja", ["getAddress", "addAddress"]),
    ...mapActions("cart", [
      "checkoutCart",
      "saveSnap",
      "getCartDetail",
      "checkoutTrx",
      "checkoutTrxStore",
      "checkoutTrxVABCA",
      "getSaldoCoinGen",
      "checkoutTrxFullCoinGen",
      "refundSaldoCoinGenFromMidtrans"
    ]),
    // ...mapActions("options", ["getOngkir", "getBankAccountList"]),
    ...mapActions("kiriminaja", [
      "getOngkir",
      "getBankAccountList",
      "getShippingFeeKiriminajaExpress",
      "getShippingFeeKiriminajaInstant",
      "actSetOngkir"
    ]),
    ...mapMutations("cart", [
      "removeCartDetail",
      "validationError",
      "setSaldoCoinGen"
    ]),
    ...mapMutations(["makeAlert"]),
    ...mapActions("profile", ["editProfileMLM", "checkMLM", "checkKTPMember"]),
    ...mapActions("store", ["getStoreByAddress"]),

    backToCart() {
      this.$router.push("/cart");
    },
    async reloadOngkir(destination, item_value, weight) {
      this.loadingProcess = await true;
      await this.actSetOngkir([]);
      await this.getShippingFeeKiriminajaExpress({
        store_id: this.detailCart.cart_store_id,
        destination: this.selectedAddress.user_address_subdistrict_id,
        item_value: this.grandTotal,
        weight: this.grandWeightTotal
      }).catch(err => {
        console.log("errrrr", err);
      });
      if (
        this.selectedAddress.user_address_longitude != "" &&
        this.selectedAddress.user_address_latitude != ""
      ) {
        let latitude = parseFloat(this.selectedAddress.user_address_latitude);
        let longitude = parseFloat(this.selectedAddress.user_address_longitude);

        await this.getShippingFeeKiriminajaInstant({
          store_id: this.detailCart.cart_store_id,
          destination_lat: latitude,
          destination_long: longitude,
          destination_address: this.selectedAddress.user_address_detail,
          item_value: this.grandTotal,
          weight: this.grandWeightTotal
        }).catch(() => {
          console.log("error instant");
        });
      }
      this.loadingProcess = await false;
    },
    addressText(value) {
      var data = [];
      if (value.user_address_detail) data.push(value.user_address_detail);
      if (value.user_address_subdistrict_name)
        data.push(value.user_address_subdistrict_name);
      if (value.user_address_city_name) data.push(value.user_address_city_name);
      if (value.user_address_province_name)
        data.push(value.user_address_province_name);
      return data.join(", ");
    },
    openModalAddAddress() {
      this.$refs.modalAddAddress.modalShow();
      this.responseError.address = "";
    },
    saveAddress(address) {
      this.selectedCour = {};
      this.addAddress(address).then(() => {
        this.getAddress().then(() => {
          this.selectedAddress = this.addressData[this.addressData.length - 1];
          this.reloadOngkir(
            this.selectedAddress.user_address_subdistrict_id,
            this.grandTotal,
            this.grandWeightTotal
          );
          // this.getOngkir({
          //   store_id: this.detailCart.cart_store_id,
          //   destination_id: this.selectedAddress.user_address_subdistrict_id
          //     ? this.selectedAddress.user_address_subdistrict_id
          //     : this.selectedAddress.user_address_city_id,
          //   destination_type: this.selectedAddress.user_address_subdistrict_id
          //     ? "subdistrict"
          //     : "city",
          //   weight: this.productTotal.weight_total
          // }).then(cour => {
          //   this.selectedCour = cour[0] ? cour[0] : {};
          // });
        });
      });
    },
    openModalAddress() {
      this.$refs.modalAddress.modalShow(this.selectedAddress);
      this.responseError.address = "";
    },
    selectAddress(address) {
      this.selectedCour = {};
      this.selectedAddress = address;
      this.reloadOngkir(
        this.selectedAddress.user_address_subdistrict_id,
        this.grandTotal,
        this.grandWeightTotal
      );
    },
    openModalCour() {
      if (!this.selectedAddress) {
        this.validationError({
          address: "Pilih Alamat terlebih dahulu"
        });
        return;
      }
      this.$refs.modalCourier.modalShow(this.selectedCour);
      this.responseError.courier = "";
    },
    selectCour(cour) {
      this.selectedCour = cour;
    },
    async validatePaste(val, ref) {
      let pasted = await val.clipboardData.getData("text");
      setTimeout(() => {
        if (!parseInt(pasted)) {
          if (ref === true) {
            this.upline = "";
          } else {
            this.sponsor = "";
          }
        }
      });
    },
    checkUserMLM(username, type) {
      if (username) {
        this.checkMLM({
          username: username
        })
          .then(({ data }) => {
            if (type == "sponsor") {
              this.sponsor_name = data.memberName;
              this.sponsor_name_error = "";
            } else if (type == "upline") {
              this.upline_name = data.memberName;
              this.upline_name_error = "";
            }
          })
          .catch(err => {
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "No. HP Upline/Sponsor tidak ditemukan",
              show: true
            });
            if (type == "sponsor") {
              this.sponsor_name_error = "No. HP Sponsor " + err.message;
              this.sponsor_name = "";
            } else if (type == "upline") {
              this.upline_name_error = "No. HP Upline " + err.message;
              this.upline_name = "";
            }
          });
      } else {
        if (type == "sponsor") {
          this.sponsor_name = "";
          this.sponsor_name_error = "";
        } else if (type == "upline") {
          this.upline_name = "";
          this.upline_name_error = "";
        }
      }
    },
    async checkout(type) {
      console.log("tyeee", type)
      console.log("this.detailCart", this.detailCart)
      const payment = value => {
        if (value == "midtrans") {
          // console.log("middd")
          this.getInvoice();
        } else if (value == "transfer") {
          this.transferManual();
        } else if (value == "payment_store") {
          this.paymentStoreConfirm();
        } else if (value == "virtual_account") {
          this.paymentVAConfirm();
        }
      };

      //jika barang yang dipilih ebook semua maka set ongkir 0
      if (this.mustChooseOngkir == false) {
        var todayDate = new Date().toISOString().slice(0, 10);

        this.selectedCour = 'pick_up';
        this.pickup_date = todayDate;

      }
      // if (this.detailCart.registration === true) {
      //   let params = {
      //     identity_number: this.identity_number,
      //     sponsor_user_username: this.sponsor,
      //     sponsor_position:
      //       this.position_by == "sponsor" ? this.position_selected : "",
      //     upline_user_username: this.position_by == "upline" ? this.upline : "",
      //     upline_position:
      //       this.position_by == "upline" ? this.position_selected : ""
      //   };
      //   this.editProfileMLM(params)
      //     .then(() => {
      //       payment(type);
      //     })
      //     .catch(err => {
      //       // this.makeAlert({ code: 'error_response', type: 'error', message: 'Terjadi kesalahan saat update data', show: true })
      //       if (err.message == "error_validation") {
      //         this.sponsor_name_error = err.data.sponsor_user_username;
      //         this.upline_name_error = err.data.upline_user_username;
      //         this.ktp_error = err.data.identity_number;
      //       }
      //     });
      // } else {
      console.log("elses validate")
      if (this.validateShipping()) {
        console.log("if true validate")

        payment(type);
      }
      // }
    },
    paymentVAConfirm() {
      this.$refs.modalConfirmVA.modalShow();
    },
    payWithVA() {
      let params = {
        shipping_method: this.selectedCour == "pick_up" ? "pick_up" : "courier",
        store_id: this.detailCart.store.store_id,
        cart_id: this.detailCart.cart_id,
        payment_method: "va",
        va_bank: "bca",
        random_number: apiAuth.getRandomNumber(),
        registration: this.detailCart.registration == true ? "true" : "false"
      };
      if (this.selectedCour == "pick_up") {
        params.pick_up_date = this.pickup_date;
      } else {
        params.address_id = this.selectedAddress.user_address_id;
        params.courier_id = this.selectedCour.id;
        params.courier_code = this.selectedCour.code;
        params.courier_etd = this.selectedCour.etd;
        params.courier_service = this.selectedCour.service;
        params.price_shipping = this.selectedCour.cost;
        params.is_drop = this.selectedCour.drop;
        params.is_cod = this.selectedCour.cod;
      }
      this.checkoutTrxVABCA(params).then(result => {
        this.removeCartDetail();
        window.location = result.finish_redirect_url;
      });
    },
    getInvoice() {
      // console.log("selectedCour", this.selectedCour);
      console.log("getInvoice");
      let items = this.detailCart.product.map(el => {
        return {
          id: el.product_id,
          name: el.product_name,
          price: el.product_price,
          note: el.product_note,
          quantity: el.cart_detail_quantity
        };
      });
      let params = {
        is_coin_gen: this.saldoCoinGen < 1 ? false : this.switchCoinGen,
        address: this.selectedAddress,
        products: items,
        price_total: this.productTotal.price_total,
        weight_total: this.productTotal.weight_total,
        user_id: this.userData.user_id,
        user_name: this.userData.user_name,
        user_mobilephone: this.userData.user_mobilephone,
        cart_id: this.detailCart.cart_id,
        shipping_method: this.selectedCour == "pick_up" ? "pick_up" : "courier",
        pick_up_date: this.pickup_date,
        courier: {
          courier_id: this.selectedCour.id,
          courier_etd: this.selectedCour.etd,
          name: this.selectedCour.code,
          cost: this.selectedCour.cost,
          service: this.selectedCour.service,
          agregator: "kiriminaja",
          is_drop: this.selectedCour.drop,
          is_cod: this.selectedCour.cod
        },
        random_number: apiAuth.getRandomNumber(),
        registration: this.detailCart.registration == true ? "true" : "false"
      };
      // console.log("parraaam", params);
      this.checkoutCart(params)
        .then(data => {
          let removecart = this.removeCartDetail;
          let router = this.$router;
          let saveSnap = this.saveSnap;
          let refundCoinGen = this.refundSaldoCoinGenFromMidtrans;
          snap.pay(data.token, {
            onSuccess: function (result) {
              console.log("success", result);
              saveSnap(result).then(() => {
                removecart();
                // window.open(result.pdf_url);
                window.location = result.finish_redirect_url;
              });
            },
            onPending: function (result) {
              console.log("pending", result);
              saveSnap(result).then(() => {
                removecart();
                // window.open(result.pdf_url);
                window.location = result.finish_redirect_url;
              });
            },
            onError: function (result) {
              console.log("error", result);
              saveSnap(result);
              // refundCoinGen(data).then(res => {
              //   console.log("result", res);
              //   console.log("data", data);
              // });
              router.push({ name: "cart" });
            },
            onClose: function (result) {
              console.log("cancle", data);
              // refundCoinGen(data).then(res => {
              //   console.log("result", res);
              //   console.log("data", data);
              // });
              console.log(
                "customer closed the popup without finishing the payment"
              );
            }
          });
        })
        .catch(msg => {
          if (msg == "Keranjang tidak ditemukan") {
            this.$router.push({ name: "cart" });
          }
        });
    },
    checkoutFullCoinGen(data) {
      console.log('dataaa');
      if (this.validateShipping()) {
        this.selectedBankAccount = data;
        let params = {
          is_coin_gen: this.switchCoinGen,
          shipping_method:
            this.selectedCour == "pick_up" ? "pick_up" : "courier",
          store_id: this.detailCart.store.store_id,
          cart_id: this.detailCart.cart_id,
          payment_method: "full_coin_gen",
          bank_account_id: this.selectedBankAccount.bank_account_id,
          random_number: apiAuth.getRandomNumber(),
          registration: this.detailCart.registration == true ? "true" : "false"
        };
        if (this.selectedCour == "pick_up") {
          params.pick_up_date = this.pickup_date;
        } else {
          params.address_id = this.selectedAddress.user_address_id;
          params.courier_id = this.selectedCour.id;
          params.courier_code = this.selectedCour.code;
          params.courier_etd = this.selectedCour.etd;
          params.courier_service = this.selectedCour.service;
          params.price_shipping = this.selectedCour.cost;
          params.agregator = "kiriminaja";
          params.is_drop = this.selectedCour.drop;
          params.is_cod = this.selectedCour.cod;
        }
        // console.log("paraams",params);
        // return false;
        this.checkoutTrxFullCoinGen(params).then(result => {
          this.removeCartDetail();
          window.location = result.finish_redirect_url;
        });
      }
    },
    checkoutTransfer(data) {
      this.selectedBankAccount = data;
      let params = {
        is_coin_gen: this.saldoCoinGen < 1 ? false : this.switchCoinGen,
        shipping_method: this.selectedCour == "pick_up" ? "pick_up" : "courier",
        store_id: this.detailCart.store.store_id,
        cart_id: this.detailCart.cart_id,
        payment_method: "bank_transfer",
        bank_account_id: this.selectedBankAccount.bank_account_id,
        random_number: apiAuth.getRandomNumber(),
        registration: this.detailCart.registration == true ? "true" : "false"
      };
      if (this.selectedCour == "pick_up") {
        params.pick_up_date = this.pickup_date;
      } else {
        params.address_id = this.selectedAddress.user_address_id;
        params.courier_id = this.selectedCour.id;
        params.courier_code = this.selectedCour.code;
        params.courier_etd = this.selectedCour.etd;
        params.courier_service = this.selectedCour.service;
        params.price_shipping = this.selectedCour.cost;
        params.agregator = "kiriminaja";
        params.is_drop = this.selectedCour.drop;
        params.is_cod = this.selectedCour.cod;
      }
      this.checkoutTrx(params).then(result => {
        this.removeCartDetail();
        window.location = result.finish_redirect_url;
      });
    },
    getCheckout() {
      this.getCartDetail({
        id: this.detailCart.cart_id
      }).catch(() => {
        this.$router.push({ name: "cart" });
      });
    },
    transferManual() {
      this.$refs.modalTransfer.modalShow(this.selectedBankAccount);
    },
    paymentStoreConfirm() {
      this.$refs.modalConfirm.modalShow();
    },
    paymentStore() {
      let params = {
        shipping_method: this.selectedCour == "pick_up" ? "pick_up" : "courier",
        store_id: this.detailCart.store.store_id,
        cart_id: this.detailCart.cart_id,
        payment_method: "payment_store",
        registration: this.detailCart.registration == true ? "true" : "false"
      };
      if (this.selectedCour == "pick_up") {
        params.pick_up_date = this.pickup_date;
      } else {
        params.address_id = this.selectedAddress.user_address_id;
        params.courier_id = this.selectedCour.id;
        params.courier_code = this.selectedCour.code;
        params.courier_etd = this.selectedCour.etd;
        params.courier_service = this.selectedCour.service;
        params.price_shipping = this.selectedCour.cost;
        params.agregator = "kiriminaja";
        params.is_drop = this.selectedCour.drop;
        params.is_cod = this.selectedCour.cod;
      }
      this.checkoutTrxStore(params).then(result => {
        this.removeCartDetail();
        window.location = result.finish_redirect_url;
      });
    },
    validateShipping() {
      console.log("selectedCour", this.selectedCour);

      if (this.selectedCour == "pick_up") {
        if (!this.pickup_date) {
          this.validationError({
            pick_up_date: "Tentukan jadwal pengambilan produk"
          });
        } else {
          return true;
        }
      } else {
        if (!this.selectedAddress) {
          this.validationError({
            address: "Pilih Alamat terlebih dahulu"
          });
        } else if (!this.selectedCour) {
          this.validationError({
            courier: "Pilih Kurir untuk melanjutkan"
          });
        } else {
          return true;
        }
      }
    },
    checkKTP() {
      this.checkKTPMember({
        identity_number: this.identity_number
      })
        .then(() => {
          this.ktp_error = "";
        })
        .catch(err => {
          if (err.message == "error_validation") {
            this.ktp_error = err.data.identity_number;
          }
        });
    },
    addressTextStore(value) {
      var data = [];
      if (value) {
        if (value.store_address) data.push(value.store_address);
        if (value.store_subdistrict_name)
          data.push(value.store_subdistrict_name);
        if (value.store_city_name) data.push(value.store_city_name);
        if (value.store_province_name) data.push(value.store_province_name);
      }
      return data.join(", ");
    }
  },
  async created() {
    if (!this.detailCart) {
      this.$router.push({ name: "cart" });
    } else {
      // this.$store.dispatch("cart", "getSaldoCoinGen");
      this.getSaldoCoinGen({});
      this.$store.dispatch("setPageTitle", "Checkout");
      this.identity_number = this.userData.user_identity_number;
      this.getCheckout();
      this.getStoreByAddress({
        id: this.detailCart.cart_store_id
      });
      this.getBankAccountList().then(bank => {
        this.selectedBankAccount = bank[0] ? bank[0] : {};
      });
      // if (this.detailCart.registration == true) {
      //   this.sponsor = this.userData.user_sponsor_user_username;
      //   this.upline = this.userData.user_upline_user_username;
      //   this.checkUserMLM(this.sponsor, "sponsor");
      //   this.checkUserMLM(this.upline, "upline");
      //   this.sponsor_position = this.userData.user_sponsor_position;
      //   this.upline_position = this.userData.user_upline_position;
      // }
      this.getAddress().then(() => {
        this.selectedAddress = this.addressData[0];
        if (this.selectedAddress) {
          this.reloadOngkir(
            this.selectedAddress.user_address_subdistrict_id,
            this.grandTotal,
            this.grandWeightTotal
          );
          // this.getOngkir({
          //   store_id: this.detailCart.cart_store_id,
          //   destination_id: this.selectedAddress.user_address_subdistrict_id
          //     ? this.selectedAddress.user_address_subdistrict_id
          //     : this.selectedAddress.user_address_city_id,
          //   destination_type: this.selectedAddress.user_address_subdistrict_id
          //     ? "subdistrict"
          //     : "city",
          //   weight: this.productTotal.weight_total
          // });
        }
      });

      await this.detailCart.product.forEach(async (row, idx) => {
        if (row.cart_detail_product_physique != 'ebook') {
          this.mustChooseOngkir = await true;
        }
      })

      //jika tidak harus pilih ongkir maka set pickup
      if (this.mustChooseOngkir == false) {
        this.selectedCour = 'pick_up'
      }
    }
  },
  mounted() {
    let midtrans = document.createElement("script");
    midtrans.setAttribute("src", midtransURL);
    midtrans.setAttribute("data-client-key", midtransKey);
    document.head.appendChild(midtrans);
  }
};
</script>
